import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getDemandSuppressionPlanMasterFormOptions } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetDemandSuppressionPlanMasterFormOptionsRequestSchema,
  type GetDemandSuppressionPlanMasterFormOptionsResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 需要抑制計画マスタ form 選択肢を集約 RPC で取得する hook。
 *
 * BFF が DR 区分でフィルタ済みの submitters / suppression_bgs と
 * 全区分の partner_bgs / businesses を返す。
 * cache key は RPC 定義のみ (area param は持たない、area narrow は client-side)。
 */
export function useGetDemandSuppressionPlanMasterFormOptions(): UseQueryResult<
  GetDemandSuppressionPlanMasterFormOptionsResponse,
  ConnectError
> {
  return useQuery(
    getDemandSuppressionPlanMasterFormOptions,
    create(GetDemandSuppressionPlanMasterFormOptionsRequestSchema, {}),
  )
}
